import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import Button from '../ui/button';

const CtaContainer = styled.section`
  padding: 6rem 0;
  background: linear-gradient(135deg, ${({ theme }) => theme.colors.primary} 0%, ${({ theme }) => theme.colors.primaryDark} 100%);
  color: white;
`;

const CtaContent = styled.div`
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 1rem;
  text-align: center;
`;

const CtaTitle = styled(motion.h2)`
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 2rem;
  }
`;

const CtaDescription = styled(motion.p)`
  font-size: 1.25rem;
  margin-bottom: 2.5rem;
  max-width: 700px;
  margin-left: auto;
  margin-right: auto;
  opacity: 0.9;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    font-size: 1.125rem;
  }
`;

const ButtonGroup = styled(motion.div)`
  display: flex;
  gap: 1rem;
  justify-content: center;
  
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    flex-direction: column;
    max-width: 300px;
    margin: 0 auto;
  }
`;

const CtaSection: React.FC = () => {
  return (
    <CtaContainer>
      <CtaContent>
        <CtaTitle
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          Ready to Streamline Your Tax Preparation?
        </CtaTitle>
        
        <CtaDescription
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          Join thousands of accounting professionals that are using FylePrep to streamline their tax preparation workflow.
          Get started today and experience a more efficient tax season.
        </CtaDescription>
        
        <ButtonGroup
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.4 }}
        >
          <Button size="large" variant="secondary" as="a" href="/waitlist">Join Waitlist</Button>
          {/* Contact Sales button commented out as requested */}
          {/* <Button size="large" variant="outline" as="a" href="mailto:info@fyleprep.com">Contact Sales</Button> */}
        </ButtonGroup>
      </CtaContent>
    </CtaContainer>
  );
};

export default CtaSection;
